import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "concierge__checkbox_unchecked",
  "use": "concierge__checkbox_unchecked-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"concierge__checkbox_unchecked\">\n  <rect fill=\"none\" height=\"13\" rx=\"1.5\" stroke=\"var(--color-primary-lighter, #374f67)\" width=\"13\" x=\"0.5\" y=\"0.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol